import React from 'react'

function Passport() {
  return (
    <div>Passport</div>
  )
}

export default Passport